import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  max-height: 400px;
  overflow-y: auto;
  padding: 8px;

  p {
    margin: 0;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`;
